import React from "react";
import {
  FcAddDatabase,
  FcApproval,
  FcAssistant,
  FcBearish,
  FcCurrencyExchange,
  FcComments,
} from "react-icons/fc";

const ServicesData = [
  {
    id: 0,
    icon: <FcAddDatabase />,
    serviceName: "serviceName",
    serviceDescription:
      "consectetur adipisicing elit. Doloremque repellendus sapiente qui modi perferendis dicta, earum accusantium quis aliquid! Voluptatibus aliquid ducimus dolorum nesciunt",
    availability: " 24/24 hour",
  },
  {
    id: 1,
    icon: <FcApproval />,
    serviceName: "serviceName",
    serviceDescription:
      "consectetur adipisicing elit. Doloremque repellendus sapiente qui modi perferendis dicta, earum accusantium quis aliquid! Voluptatibus aliquid ducimus dolorum nesciunt",
    availability: " 12/24 hour",
  },
  {
    id: 2,
    icon: <FcAssistant />,
    serviceName: "serviceName",
    serviceDescription:
      "consectetur adipisicing elit. Doloremque repellendus sapiente qui modi perferendis dicta, earum accusantium quis aliquid! Voluptatibus aliquid ducimus dolorum nesciunt",
    availability: " 24/24 hour",
  },
  {
    id: 3,
    icon: <FcBearish />,
    serviceName: "serviceName",
    serviceDescription:
      "consectetur adipisicing elit. Doloremque repellendus sapiente qui modi perferendis dicta, earum accusantium quis aliquid! Voluptatibus aliquid ducimus dolorum nesciunt",
    availability: " 12/24 hour",
  },
  {
    id: 4,
    icon: <FcCurrencyExchange />,
    serviceName: "serviceName",
    serviceDescription:
      "consectetur adipisicing elit. Doloremque repellendus sapiente qui modi perferendis dicta, earum accusantium quis aliquid! Voluptatibus aliquid ducimus dolorum nesciunt",
    availability: " 24/24 hour",
  },
  {
    id: 5,
    icon: <FcComments />,
    serviceName: "serviceName",
    serviceDescription:
      "consectetur adipisicing elit. Doloremque repellendus sapiente qui modi perferendis dicta, earum accusantium quis aliquid! Voluptatibus aliquid ducimus dolorum nesciunt",
    availability: " 24/24 hour",
  },
];

export default ServicesData;
